(function () {
    'use strict';

    angular.module('app.basicPages.terms', [
        'app.core',
        'components.siteText'
    ]);
})();